// Hand-written — NOT auto-generated by NSwag.
// These ABP TokenAuth classes are excluded from the NSwag spec but are still
// required by the login/auth flows. Keep this file; do NOT overwrite on NSwag runs.

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';
import { API_BASE_URL } from './service-proxies';

// ---------------------------------------------------------------------------
// Models
// ---------------------------------------------------------------------------

export class AuthenticateModel {
    userNameOrEmailAddress!: string | undefined;
    password!: string | undefined;
    rememberClient!: boolean;
    twoFactorVerificationCode!: string | undefined;
    twoFactorRememberClientToken!: string | undefined;
    singleSignIn!: boolean | undefined;
    returnUrl!: string | undefined;
    captchaResponse!: string | undefined;

    init(data?: any) {
        if (data) {
            this.userNameOrEmailAddress = data['userNameOrEmailAddress'];
            this.password = data['password'];
            this.rememberClient = data['rememberClient'];
            this.twoFactorVerificationCode = data['twoFactorVerificationCode'];
            this.twoFactorRememberClientToken = data['twoFactorRememberClientToken'];
            this.singleSignIn = data['singleSignIn'];
            this.returnUrl = data['returnUrl'];
            this.captchaResponse = data['captchaResponse'];
        }
    }

    static fromJS(data: any): AuthenticateModel {
        data = typeof data === 'object' ? data : {};
        const result = new AuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(): any {
        const data: any = {};
        data['userNameOrEmailAddress'] = this.userNameOrEmailAddress;
        data['password'] = this.password;
        data['rememberClient'] = this.rememberClient;
        data['twoFactorVerificationCode'] = this.twoFactorVerificationCode;
        data['twoFactorRememberClientToken'] = this.twoFactorRememberClientToken;
        data['singleSignIn'] = this.singleSignIn;
        data['returnUrl'] = this.returnUrl;
        data['captchaResponse'] = this.captchaResponse;
        return data;
    }
}

export class AuthenticateResultModel {
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number | undefined;
    shouldResetPassword!: boolean | undefined;
    passwordResetCode!: string | undefined;
    userId!: number | undefined;
    requiresTwoFactorVerification!: boolean | undefined;
    twoFactorAuthProviders!: string[] | undefined;
    twoFactorRememberClientToken!: string | undefined;
    returnUrl!: string | undefined;
    refreshToken!: string | undefined;
    refreshTokenExpireInSeconds!: number | undefined;
    isError!: boolean;
    errorMessage!: string | undefined;

    init(data?: any) {
        if (data) {
            this.accessToken = data['accessToken'];
            this.encryptedAccessToken = data['encryptedAccessToken'];
            this.expireInSeconds = data['expireInSeconds'];
            this.shouldResetPassword = data['shouldResetPassword'];
            this.passwordResetCode = data['passwordResetCode'];
            this.userId = data['userId'];
            this.requiresTwoFactorVerification = data['requiresTwoFactorVerification'];
            this.twoFactorAuthProviders = data['twoFactorAuthProviders'];
            this.twoFactorRememberClientToken = data['twoFactorRememberClientToken'];
            this.returnUrl = data['returnUrl'];
            this.refreshToken = data['refreshToken'];
            this.refreshTokenExpireInSeconds = data['refreshTokenExpireInSeconds'];
            this.isError = data['isError'] || false;
            this.errorMessage = data['errorMessage'];
        }
    }

    static fromJS(data: any): AuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        const result = new AuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(): any {
        const data: any = {};
        data['accessToken'] = this.accessToken;
        data['encryptedAccessToken'] = this.encryptedAccessToken;
        data['expireInSeconds'] = this.expireInSeconds;
        data['twoFactorRememberClientToken'] = this.twoFactorRememberClientToken;
        data['returnUrl'] = this.returnUrl;
        data['isError'] = this.isError;
        return data;
    }
}

export class ExternalLoginProviderInfoModel {
    name!: string | undefined;
    clientId!: string | undefined;

    init(data?: any) {
        if (data) {
            this.name = data['name'];
            this.clientId = data['clientId'];
        }
    }

    static fromJS(data: any): ExternalLoginProviderInfoModel {
        data = typeof data === 'object' ? data : {};
        const result = new ExternalLoginProviderInfoModel();
        result.init(data);
        return result;
    }

    toJSON(): any {
        return { name: this.name, clientId: this.clientId };
    }
}

export class ExternalAuthenticateModel {
    authProvider!: string | undefined;
    providerKey!: string | undefined;
    providerAccessCode!: string | undefined;
    returnUrl!: string | undefined;
    singleSignIn!: boolean | undefined;
    idToken!: string | undefined;
    authCodeToGetToken!: string | undefined;
    emailAddress!: string | undefined;
    name!: string | undefined;
    surname!: string | undefined;

    init(data?: any) {
        if (data) {
            this.authProvider = data['authProvider'];
            this.providerKey = data['providerKey'];
            this.providerAccessCode = data['providerAccessCode'];
            this.returnUrl = data['returnUrl'];
            this.singleSignIn = data['singleSignIn'];
            this.idToken = data['idToken'];
            this.authCodeToGetToken = data['authCodeToGetToken'];
            this.emailAddress = data['emailAddress'];
            this.name = data['name'];
            this.surname = data['surname'];
        }
    }

    static fromJS(data: any): ExternalAuthenticateModel {
        data = typeof data === 'object' ? data : {};
        const result = new ExternalAuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(): any {
        const data: any = {};
        data['authProvider'] = this.authProvider;
        data['providerKey'] = this.providerKey;
        data['providerAccessCode'] = this.providerAccessCode;
        data['returnUrl'] = this.returnUrl;
        data['singleSignIn'] = this.singleSignIn;
        data['idToken'] = this.idToken;
        data['authCodeToGetToken'] = this.authCodeToGetToken;
        data['emailAddress'] = this.emailAddress;
        data['name'] = this.name;
        data['surname'] = this.surname;
        return data;
    }
}

export class ExternalAuthenticateResultModel {
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number | undefined;
    waitingForActivation!: boolean | undefined;
    returnUrl!: string | undefined;
    userNotExists!: boolean | undefined;
    isPublicDomain!: boolean | undefined;
    /** D-02 (OB-E-08): the Microsoft 365 sign-up could not create the workspace (HTTP 200, no token). Twin of the C# SignUpFailed. */
    signUpFailed!: boolean | undefined;
    refreshToken!: string | undefined;
    refreshTokenExpireInSeconds!: number | undefined;

    init(data?: any) {
        if (data) {
            this.accessToken = data['accessToken'];
            this.encryptedAccessToken = data['encryptedAccessToken'];
            this.expireInSeconds = data['expireInSeconds'];
            this.waitingForActivation = data['waitingForActivation'];
            this.returnUrl = data['returnUrl'];
            this.userNotExists = data['userNotExists'];
            this.isPublicDomain = data['isPublicDomain'];
            this.signUpFailed = data['signUpFailed'];
            this.refreshToken = data['refreshToken'];
            this.refreshTokenExpireInSeconds = data['refreshTokenExpireInSeconds'];
        }
    }

    static fromJS(data: any): ExternalAuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        const result = new ExternalAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(): any {
        const data: any = {};
        data['accessToken'] = this.accessToken;
        data['encryptedAccessToken'] = this.encryptedAccessToken;
        data['expireInSeconds'] = this.expireInSeconds;
        data['waitingForActivation'] = this.waitingForActivation;
        data['returnUrl'] = this.returnUrl;
        data['userNotExists'] = this.userNotExists;
        data['isPublicDomain'] = this.isPublicDomain;
        data['signUpFailed'] = this.signUpFailed;
        return data;
    }
}

// ---------------------------------------------------------------------------
// Service proxies
// ---------------------------------------------------------------------------

@Injectable()
export class TokenAuthServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? '';
    }

    authenticate(body: AuthenticateModel | null | undefined): Observable<AuthenticateResultModel> {
        let url_ = this.baseUrl + '/api/TokenAuth/Authenticate';
        url_ = url_.replace(/[?&]$/, '');
        const content_ = JSON.stringify(body ? body.toJSON() : null);
        const options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({ 'Content-Type': 'application/json', Accept: 'application/json' })
        };

        return this.http.request('post', url_, options_).pipe(
            _observableMergeMap((response_: any) => this._processAuthenticate(response_)),
            _observableCatch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try { return this._processAuthenticate(response_ as any); } catch (e) {
                        return _observableThrow(e) as any as Observable<AuthenticateResultModel>;
                    }
                }
                return _observableThrow(response_) as any as Observable<AuthenticateResultModel>;
            })
        );
    }

    private _processAuthenticate(response: HttpResponseBase): Observable<AuthenticateResultModel> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        if (status === 200) {
            return _blobToText(responseBlob).pipe(_observableMergeMap(text => {
                const data = text === '' ? null : _safeParse(text);
                return _observableOf(AuthenticateResultModel.fromJS(data || {}));
            }));
        }
        return _blobToText(responseBlob).pipe(_observableMergeMap(text => {
            return _observableThrow(new Error('An unexpected server error occurred. Status: ' + status));
        }));
    }

    externalAuthenticate(body: ExternalAuthenticateModel | null | undefined): Observable<ExternalAuthenticateResultModel> {
        let url_ = this.baseUrl + '/api/TokenAuth/ExternalAuthenticate';
        url_ = url_.replace(/[?&]$/, '');
        const content_ = JSON.stringify(body ? body.toJSON() : null);
        const options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({ 'Content-Type': 'application/json', Accept: 'application/json' })
        };

        return this.http.request('post', url_, options_).pipe(
            _observableMergeMap((response_: any) => this._processExternalAuthenticate(response_)),
            _observableCatch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try { return this._processExternalAuthenticate(response_ as any); } catch (e) {
                        return _observableThrow(e) as any as Observable<ExternalAuthenticateResultModel>;
                    }
                }
                return _observableThrow(response_) as any as Observable<ExternalAuthenticateResultModel>;
            })
        );
    }

    private _processExternalAuthenticate(response: HttpResponseBase): Observable<ExternalAuthenticateResultModel> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        if (status === 200) {
            return _blobToText(responseBlob).pipe(_observableMergeMap(text => {
                const data = text === '' ? null : _safeParse(text);
                return _observableOf(ExternalAuthenticateResultModel.fromJS(data || {}));
            }));
        }
        return _blobToText(responseBlob).pipe(_observableMergeMap(text => {
            return _observableThrow(new Error('An unexpected server error occurred. Status: ' + status));
        }));
    }

    getExternalAuthenticationProviders(): Observable<ExternalLoginProviderInfoModel[]> {
        let url_ = this.baseUrl + '/api/TokenAuth/GetExternalAuthenticationProviders';
        url_ = url_.replace(/[?&]$/, '');
        const options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({ Accept: 'application/json' })
        };

        return this.http.request('get', url_, options_).pipe(
            _observableMergeMap((response_: any) => this._processGetExternalProviders(response_)),
            _observableCatch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try { return this._processGetExternalProviders(response_ as any); } catch (e) {
                        return _observableThrow(e) as any as Observable<ExternalLoginProviderInfoModel[]>;
                    }
                }
                return _observableThrow(response_) as any as Observable<ExternalLoginProviderInfoModel[]>;
            })
        );
    }

    private _processGetExternalProviders(response: HttpResponseBase): Observable<ExternalLoginProviderInfoModel[]> {
        const status = response.status;
        const responseBlob = response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        if (status === 200) {
            return _blobToText(responseBlob).pipe(_observableMergeMap(text => {
                const data = text === '' ? null : _safeParse(text);
                const result: ExternalLoginProviderInfoModel[] = [];
                if (Array.isArray(data)) {
                    for (const item of data) {
                        result.push(ExternalLoginProviderInfoModel.fromJS(item));
                    }
                }
                return _observableOf(result);
            }));
        }
        if (status === 404) {
            return _observableOf([]);
        }
        return _blobToText(responseBlob).pipe(_observableMergeMap(text => {
            return _observableThrow(new Error('An unexpected server error occurred. Status: ' + status));
        }));
    }
}

@Injectable()
export class TokenServiceProxy {
    constructor(@Inject(HttpClient) _http: HttpClient, @Optional() @Inject(API_BASE_URL) _baseUrl?: string) {}
}

// ---------------------------------------------------------------------------
// Helpers (local copies — service-proxies.ts versions are not exported)
// ---------------------------------------------------------------------------

function _blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next('');
            observer.complete();
        } else {
            const reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}

function _safeParse(text: string): any {
    try { return JSON.parse(text); } catch { return null; }
}
